import { render, staticRenderFns } from "./MultiplicationAdditionEquivalence.vue?vue&type=template&id=6154b19d&"
import script from "./MultiplicationAdditionEquivalence.vue?vue&type=script&lang=js&"
export * from "./MultiplicationAdditionEquivalence.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports